module.exports = __webpack_public_path__ + "../resources/graphql/schema.all.min-87dfc6ac5ad69f5b5d63a26ca7989784.graphql";